import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import styled, { css } from "styled-components";
var CardWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n \toverflow: hidden;\n\tborder-radius: 10px;\n\n\t", "\n\n\t", "\n\t", "\n\t", "\n\t", "\n\t", ";\n\t", ";\n\n\t@media (max-width: 1024px) {\n\t\tborder-radius: ", ";\n\t}\n\n\t@media (max-width: 475px) {\n\t\tborder-radius: ", ";\n\t}\n"])), function (props) {
  return props.shadow && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbox-shadow: 0 4px 10px 0 rgba(219, 221, 227, 0.5);\n\t\t"])));
}, function (props) {
  return props.border && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\tborder: ", ";\n\t\t"])), props.border);
}, function (props) {
  return props.backgroundImage && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tbackground-image: url(", ");\n\t\t\tbackground-size: cover;\n\t\t\tbackground-position: center;\n\t\t"])), props.backgroundImage);
}, function (props) {
  return props.backgroundColor && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t"])), props.backgroundColor);
}, function (props) {
  return props.padding && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\tpadding: ", ";\n\t\t"])), props.padding);
}, function (props) {
  return props.width && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\twidth: ", ";\n\t\t"])), props.width);
}, function (props) {
  return props.height && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\theight: ", ";\n\t\t"])), props.height);
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.borderRadius;
});
export var Card = function Card(_ref) {
  var children = _ref.children,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["children", "onClick"]);

  return /*#__PURE__*/React.createElement(CardWrapper, _extends({
    onClick: function onClick() {
      return _onClick();
    }
  }, props), children);
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

Card.defaultProps = {
  onClick: function onClick() {
    return null;
  },
  borderRadius: "10px"
};